export const BOOTH_POSITIONS = [
  // left column
  {
    position: [-30.5, 0, 45],
    rotation: 3.49066,
  },
  {
    position: [-37.5, 0, 22.5],
    rotation: 3.49066,
  },
  {
    position: [-37.5, 0, 0],
    rotation: 3.49066,
  },
  {
    position: [-37.5, 0, -22.5],
    rotation: 3.49066,
  },
  {
    position: [-37.5, 0, -45],
    rotation: 3.49066,
  },
  {
    position: [-20.5, 0, -60],
    rotation: Math.PI,
  },
  // middle column
  {
    position: [0, 0, 30],
    rotation: Math.PI,
  },
  {
    position: [0, 0, 10],
    rotation: Math.PI,
  },
  {
    position: [0, 0, -10],
    rotation: Math.PI,
  },
  {
    position: [0, 0, -30],
    rotation: Math.PI,
  },
  {
    position: [30, 0, 45],
    rotation: -3.49066,
  },
  // right column
  {
    position: [37.5, 0, 22.5],
    rotation: -3.49066,
  },
  {
    position: [37.5, 0, 0],
    rotation: -3.49066,
  },
  {
    position: [37.5, 0, -22.5],
    rotation: -3.49066,
  },
  {
    position: [37.5, 0, -45],
    rotation: -3.49066,
  },
  {
    position: [22, 0, -60],
    rotation: Math.PI,
  },
];
